import { motion } from "framer-motion";
import { ShieldCheck, Truck } from "lucide-react";

export default function FinalCTA({ onBuy }) {
    return (
        <section data-testid="final-cta-section" className="relative overflow-hidden py-28 md:py-40 border-t border-white/10">
            <div className="spotlight absolute inset-0" />
            <span aria-hidden className="font-display text-stroke absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[24vw] leading-none font-700 uppercase whitespace-nowrap select-none pointer-events-none">
                COOL
            </span>
            <div className="relative max-w-4xl mx-auto px-5 text-center">
                <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="font-display uppercase font-700 tracking-tighter text-4xl sm:text-5xl md:text-7xl leading-[0.95]"
                >
                    Summer won't wait.<br />
                    <span className="text-cyan-300">Stay cool anywhere.</span>
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.15 }}
                    className="mt-6 text-zinc-400 text-base md:text-lg max-w-lg mx-auto leading-relaxed"
                >
                    3s instant cooling, 12-hour battery, 100 speeds — in your pocket. Get yours today.
                </motion.p>
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.25 }}
                    className="mt-10"
                >
                    <button
                        onClick={onBuy}
                        data-testid="final-cta-buy-button"
                        className="glow-btn rounded-full bg-cyan-300 text-black font-bold uppercase tracking-[0.15em] text-sm md:text-base px-12 py-5 transition-transform duration-300 hover:scale-105 active:scale-95"
                    >
                        Get Yours Today
                    </button>
                    <div className="mt-8 flex justify-center gap-8 text-xs uppercase tracking-[0.15em] text-zinc-500">
                        <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-cyan-300/80" /> Secure checkout</span>
                        <span className="flex items-center gap-2"><Truck className="w-4 h-4 text-cyan-300/80" /> Ships in 24–48h</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
